//Install
import React, { Component } from "react";
//Install
import { ReactComponent as U79Z9W } from "../../../../../Media/Brand/006.svg";

//Element
class DB6F84 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx y86685" },
            //Element
            React.createElement(U79Z9W, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default DB6F84;